
  var _styles = {
  "content-wrap": {
    "background": "#fff",
    "paddingTop": "0.26667rem",
    "paddingRight": 0,
    "paddingBottom": "0.32rem",
    "paddingLeft": 0,
    "marginTop": 0,
    "marginRight": "0.32rem",
    "marginBottom": 0,
    "marginLeft": "0.32rem",
    "borderRadius": "0.32rem",
    "position": "relative"
  },
  "indicator-arrow": {
    "width": "0.36rem",
    "height": "0.12rem",
    "position": "absolute",
    "top": "-0.12rem",
    "right": "0.30667rem",
    "zIndex": 1
  },
  "content-title": {
    "height": "0.69333rem",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "display": "flex",
    "flexDirection": "row"
  },
  "content-title-text": {
    "color": "rgb(34,34,34)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.42667rem",
    "lineHeight": "0.69333rem",
    "height": "0.69333rem"
  },
  "content-main": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "flexWrap": "wrap",
    "paddingLeft": "0.32rem",
    "paddingRight": "0.21333rem"
  },
  "content-text": {
    "color": "rgb(136,136,136)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "lineHeight": "0.58667rem",
    "textAlign": "left",
    "fontWeight": "400"
  },
  "landmark-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "lineHeight": "0.58667rem",
    "textAlign": "left",
    "fontWeight": "600",
    "marginTop": 0,
    "marginRight": "0.05333rem",
    "marginBottom": 0,
    "marginLeft": "0.05333rem"
  },
  "filter-card-scroll": {
    "paddingTop": "0.26667rem",
    "paddingLeft": "0.32rem"
  },
  "filter-card-wrap": {
    "height": "1.17333rem",
    "paddingTop": "0.10667rem",
    "paddingRight": "0.21333rem",
    "paddingBottom": "0.10667rem",
    "paddingLeft": "0.21333rem",
    "marginRight": "0.16rem",
    "backgroundColor": "rgb(247,247,247)",
    "borderRadius": "0.21333rem"
  },
  "filter-card-wrap-selected": {
    "backgroundColor": "rgb(240,247,255)"
  },
  "filter-card-title-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "filter-card-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.34667rem",
    "lineHeight": "0.48rem",
    "textAlign": "left"
  },
  "filter-card-title-selected": {
    "color": "rgb(0,64,153)"
  },
  "filter-card-sub-text": {
    "fontWeight": "400",
    "color": "rgb(136,136,136)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "lineHeight": "0.42667rem"
  },
  "filter-card-sub-text-selected": {
    "color": "rgb(0,64,153)"
  },
  "ellipsis-wrap": {
    "width": "0.68rem",
    "height": "0.4rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "justifyContent": "space-between",
    "marginLeft": "0.16rem"
  },
  "loading-dot": {
    "width": "0.68rem",
    "height": "0.12rem"
  },
  "scroll-empty-view": {
    "width": "0.16rem"
  }
};



  module.exports = _styles;
  